module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "充值VIP",
      "width": "500px",
      "visible": _vm.formVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      },
      "close": _vm.closeFun
    }
  }, [_c('div', [_c('div', {
    staticClass: "contDiv"
  }, [_c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "tits"
  }, [_vm._v("VIP 1")]), _vm._v(" "), _c('div', {
    staticClass: "pay-wars"
  }, [_vm._v("目前仅支持余额扣款!!!")]), _vm._v(" "), _c('div', {
    staticClass: "conts"
  }, [_vm._v("2 TB")]), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('el-button', {
    staticClass: "chongBtn",
    attrs: {
      "type": "warning",
      "loading": _vm.submiting
    },
    on: {
      "click": function($event) {
        return _vm.chongVipFun(1, 1)
      }
    }
  }, [_vm._v("15元/月")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('el-button', {
    staticClass: "chongBtn",
    attrs: {
      "type": "danger",
      "loading": _vm.submiting
    },
    on: {
      "click": function($event) {
        return _vm.chongVipFun(1, 12)
      }
    }
  }, [_vm._v("150元/年")])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "tits"
  }, [_vm._v("VIP 2")]), _vm._v(" "), _c('div', {
    staticClass: "pay-wars"
  }, [_vm._v("目前仅支持余额扣款!!!")]), _vm._v(" "), _c('div', {
    staticClass: "conts"
  }, [_vm._v("5 TB")]), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('el-button', {
    staticClass: "chongBtn",
    attrs: {
      "type": "warning",
      "loading": _vm.submiting
    },
    on: {
      "click": function($event) {
        return _vm.chongVipFun(2, 1)
      }
    }
  }, [_vm._v("30元/月")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_c('el-button', {
    staticClass: "chongBtn",
    attrs: {
      "type": "danger",
      "loading": _vm.submiting
    },
    on: {
      "click": function($event) {
        return _vm.chongVipFun(2, 12)
      }
    }
  }, [_vm._v("300元/年")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "infotxts"
  }, [_c('ul', [_c('li', [_vm._v("空间大小会随"), _c('span', {
    staticStyle: {
      "color": "#fd8f1c"
    }
  }, [_vm._v("上个月收入而变化")]), _vm._v(": !")]), _vm._v(" "), _c('li', [_vm._v("默认为 "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("50GB")]), _vm._v(" ! ! !")]), _vm._v(" "), _c('li', [_vm._v("如果上个月收入大于 "), _c('span', {
    staticStyle: {
      "color": "#f60"
    }
  }, [_vm._v("500")]), _vm._v(",则空间为 "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("100GB")]), _vm._v(" !")]), _vm._v(" "), _c('li', [_vm._v("如果上个月收入大于 "), _c('span', {
    staticStyle: {
      "color": "#f60"
    }
  }, [_vm._v("1000")]), _vm._v(",则空间为 "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("200GB")]), _vm._v(" !")]), _vm._v(" "), _c('li', [_vm._v("如果上个月收入大于 "), _c('span', {
    staticStyle: {
      "color": "#f60"
    }
  }, [_vm._v("2000")]), _vm._v(",则空间为 "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("300GB")]), _vm._v(" !")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12bf76a3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChongVip.vue
// module id = 1150
// module chunks = 1